// Utils
import { sortChanges } from './sortChanges';
import { applyArrayChanges } from './applyArrayChanges';
import { applyPropertyDeletionChanges } from './applyPropertyDeletionChanges';
import { applyPropertyValueChanges } from './applyPropertyValueChanges';
/**
 * To the given object apply the list of given changes
 *
 * @template T extends object
 * @param {T} values
 * @param {ChangeList} changes
 * @param {ApplyChangesOptions} options
 *
 * @return {T}
 */
export var applyChanges = function (values, changes, options) {
    if (options === void 0) { options = {}; }
    if (Object.keys(changes).length === 0) {
        return values;
    }
    var newValues = values;
    var _a = sortChanges(changes), newObjects = _a.newObjects, propertyDeletions = _a.propertyDeletions, arrayChanges = _a.arrayChanges, valueChanges = _a.valueChanges;
    newValues = applyPropertyDeletionChanges(newValues, propertyDeletions);
    newValues = applyPropertyValueChanges(newValues, valueChanges, newObjects);
    newValues = applyArrayChanges(newValues, arrayChanges, newObjects, options.isMergeableCollection);
    return newValues;
};
//# sourceMappingURL=applyChanges.js.map